/**
 * Axis labels for the activity heatmap.
 *
 * The synthetic `buildHeatColumns()` that used to live here is gone: the grid
 * renders real daily usage via `planUsageHeatmapFromUsage.js`, and leaving a
 * plausible-looking fake generator beside it invites accidental reuse.
 */
export const HEATMAP_MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const HEATMAP_WEEKDAY_LABELS = ['', 'M', '', 'W', '', 'F', '']
